<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">错误码管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" label-width="30px" class="user-search">
            <el-form-item label=" ">
                <el-button size="small" type="primary" @click="addClick">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table size="small" :data="listData" highlight-current-row border  style="width: 100%;">
        <el-table-column  prop="errCode" label="错误码" >
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="errMessage" label="含义" >
        </el-table-column>
            <el-table-column align="center" label="操作" >
                <template slot-scope="scope">
                <el-button type="text" v-preventReClick @click="handleEdit(scope.row)">编辑</el-button>
                <el-button type="text" v-preventReClick @click="delClick(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->

        <el-dialog :visible.sync="editFormVisible" width="30%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="错误码" prop="errCode">
                    <el-input el-input size="small" v-model="editForm.errCode" auto-complete="off" placeholder="请输入错误码"></el-input>
                </el-form-item>
                <el-form-item label="含义" prop="errMessage">
                    <el-input el-input size="small"  v-model="editForm.errMessage" auto-complete="off" placeholder="请输入含义"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
    
<script>
import Pagination from '../../components/Pagination'
import { loadErrorList , saveError , deleteError } from '../../api/userMG'
export default {
    data () {
        return {
            loading:false,
            rules:{},
            editFlag:false,
            editForm:{
                errCode:'',
                errMessage:'',
                id:'',
            },
            editFormVisible:false,
            content: '<h2>I</h2><p>这是射，么就卡奇我觉额定</p><p>啊索拉卡到家啊了肯定</p><p>接口</p>',
            editorOption: {
            // Some Quill options...
            },
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                nickName: '',
            },
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            rules: {
                errCode : [
                { required: true, message: '请输入错误码', trigger: 'blur' },
                { message: '格式错误',trigger: 'blur', pattern:/^[0-9]*$/}
                ],
                errMessage: [
                { required: true, message: '请输入含义', trigger: 'blur' }
                ],
            },
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
    },
    methods: {
        delClick(row){
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteError({id:row.id}).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.getdata()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },  
        addClick(){
            this.editFlag = false
            this.editFormVisible = true
            this.editForm = {
                errCode:'',
                errMessage:'',
                id:''
            }
        },  
        submitForm(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    saveError(this.editForm).then(res=>{
                        if(!res.success){
                            this.$message.error(res.messages)
                        }else {
                            this.$message.success(this.editForm.id == ''?'创建成功':'修改成功')
                            this.getdata()
                            this.editFormVisible = false
                            this.editForm = {
                                errCode:'',
                                errMessage:'',
                                id:''
                            }
                        }
                    })
                } else {
                    return false
                }
            })
        },  

        
        handleEdit(row){
            this.editForm = {
                errCode:row.errCode,
                errMessage:row.errMessage,
                id:row.id
            }
            this.editFormVisible = true
        },
        closeDialog(){
            this.$refs.editForm.clearValidate();
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        getdata(){
            loadErrorList().then(res=>{
                this.listData = res.errorList
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    },
    computed: {
		editor() {
			return this.$refs.myQuillEditor.quill
		}
    },
    mounted() {
    // console.log('this is current quill instance object', this.editor)
    },
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/system/errorCode.vue